module.exports = __webpack_public_path__ + "static/media/05.Lankini.e7400af1.jpg";